<template>
  <v-container>

    <v-row>
      <v-col>
        <h2>
          {{ title }}
        </h2>
      </v-col>
    </v-row>

    <v-row>

      <v-col
        v-for="option in options"
        v-bind:key="option.id"
        cols="2"
      >
        <v-row v-if="loading" justify="center" align="center">
          <v-progress-circular
            indeterminate
            color="rgba(183,175,200,1)"
          ></v-progress-circular>
        </v-row>
        <Option v-else v-bind:option="option" v-bind:counter="counter" v-bind:selectable="!recommendations" v-on:selected="select" v-on:unselected="unselect"/>

      </v-col>

      <v-col cols=1 v-if="!recommendations">
      </v-col>
      <v-col cols=4 v-if="!recommendations">
        
        <v-card>
          <v-card-text>
            <p>Did you know?</p>
            <p> The semantic search is... </p>
          </v-card-text>
        </v-card>

      </v-col>

    </v-row>

  </v-container>
</template>

<script>
import Preference from '@/persistency/Preference.js'
import Option from '@/components/subcomponents/Option.vue'

export default {
  name: 'Options',

  components: {
    Option
  },
  
  props: {
    loading: Boolean,
    recommendations: Boolean,
    title: String,
    options: Array
  },

  data: function() {
    return {
      counter: 1,
      preferences: {}
    }
  },
  
  methods: {

    select: function(id) {

      // Do not allow selection in recommendations mode
      if(this.recommendations){
        return 
      }

      // Selected item
      this.preferences[id] = new Preference(id, this.counter)
      this.counter += 1

      // Notify father if choice is complete
      if(this.counter > 3){

        // Get preferences as array
        const choices = []
        for(const id in this.preferences){
          choices.push(this.preferences[id])
        }

        // Re-init the data
        this.counter = 1
        this.preferences = {}

        // Emit event
        this.$emit("choice-done", choices)
      
      }

    },

    unselect: function(id, order) {
      console.log("Unselect "+ id + " " + order + " - todo")
    }

  }
  
}

</script>

<style scoped>

p {
  margin-bottom: 0;
}

.selected {
  margin: 6%;
}

#retry {
  height: 20vh;
}

</style>
